import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
  ContainerRoot: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  buttons: {
    height: 44,
    letterSpacing: 1.25,
    fontSize: 16,
    fontWeight: '400',
    minWidth: 'unset'
  },
  outlined: {
    background: '#FFFFFF',
    fontWeight: '500',
    '&:hover': {
      background: '#FFFFFF',
      opacity: 0.8
    },
    '&:focus': {
      background: '#FFFFFF',
      opacity: 0.8
    }
  },
  icon: {
    fill: theme.palette.primary.main
  },
  input: {
    width: '100%'
  },
  horizontalPadding: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(3)
  },
  cardsRow: {
    display: 'flex',
    marginTop: theme.spacing(3)
  },
  totalCard: {
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    width: '50%',
    padding: theme.spacing(4)
  },
  periodCard: {
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    width: '25%',
    marginLeft: 'auto',
    padding: theme.spacing(4)
  },
  cardLabel: {
    display: 'block',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  cardIcon: {
    width: theme.spacing(9),
    height: theme.spacing(9),
    background: theme.palette.badge.success.bg,
    color: theme.palette.badge.success.text,
    borderRadius: theme.shape.borderRadius,
    marginRight: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
}));
